export default "__VITE_ASSET__D4wljNt4__"